<h2 mat-dialog-title class="dialog-header">
  <span class="dialog-title title-large">Ricevuta</span>

  <button
    mat-icon-button
    mat-dialog-close
    type="button"
    aria-label="Chiudi"
    class="close-button"
  >
    <i class="fa-regular fa-xmark"></i>
  </button>
</h2>

<mat-dialog-content class="receipt-content">
  <div class="receipt-success">
    <div class="receipt-success-icon" aria-hidden="true">
      <i class="fa-regular fa-check"></i>
    </div>

    <span class="label-medium-emphasized">Ricevuta emessa</span>
    <span class="label-small">N° {{ data.numero }}</span>
  </div>

  <div class="receipt-card">
    <div class="receipt-row">
      <span class="body-small">Cliente:</span>
      <span class="body-small-emphasized receipt-value">{{ data.cliente }}</span>
    </div>

    <div class="receipt-row">
      <span class="body-small">Metodo:</span>
      <span class="body-small-emphasized receipt-value">{{ data.metodo }}</span>
    </div>

    <div class="receipt-row">
      <span class="body-small">Importo:</span>
      <span class="body-small-emphasized receipt-value">{{ formatAmount(data.importo) }}</span>
    </div>

    <div class="receipt-allocated-items">
      <span class="body-small">Partite imputate:</span>

      @for (item of data.partiteImputate; track item.documento) {
        <span class="body-small-emphasized">
          {{ item.documento }} ({{ item.descrizione }} {{ formatAmount(item.importo) }})
        </span>
      }
    </div>
  </div>

  @if (data.email) {
    <div class="receipt-email-message body-small">
      Ricevuta inviata via e-mail a: {{ data.email }}, agente, {{ data.agente }}
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions class="receipt-actions">
  <button matButton="filled" mat-dialog-close type="button">Torna alla Home</button>
  <button matButton="outlined" type="button" (click)="data.onDownloadPdf?.()">Scarica PDF</button>
</mat-dialog-actions>
